// Источник изображения мини-Луни. Артов пока нет — используем облегчённый 300×300
// (assets/lunya-300.png в макетах), достаточный для мелких размеров аватара.
export const LUNYA_AVATAR_SRC = '/images/lunya-300.png'
